import Vue from "vue";
import Vuex from "vuex";
Vue.use(Vuex);

export default {
    state: {
        hospitals: [
        ],
        selectedHospital: undefined
    },
    mutations: {
        setHospitals(state, payload) {
            state.hospitals = payload
        },
        setSelectedHospital(state, payload) {
            state.selectedHospital = payload;
        },
    },
    actions: {

        async addNewHospital({ commit,rootState }, payload) {
            let headerConfig = {
                headers: {
                    Authorization: `bearer ${rootState.User.userToken}`
                }
            }
            return await this.$http.post("/api/administrators/hospitals",payload, headerConfig)
                .then(response => {
                    return response.status;
                })
                .catch(error=>{
                   return error;
                });
        },

        async loadHospitals({ commit, rootState,getters }) {
            let headerConfig = {
                headers: {
                    Authorization: `bearer ${rootState.User.userToken}`
                }
            }
            let role  = getters.user.roles[0].name;
            if (role === "admin"){
                role = 'administrators'
            }
            return await this.$http.get(`/api/${role}/hospitals`, headerConfig)
                .then(response => {
                    commit("setHospitals", response.data.hospitals);
                })
                .catch( error =>{
                    console.log('Erro ao recuperar hospital\nError=',error);
                });
        },

        async removeHospital( { rootState }, id) {
            let headerConfig = {
                headers: {
                    Authorization: `bearer ${rootState.User.userToken}`
                }
            }
            return await this.$http.delete(`/api/administrators/hospitals/${id}`, headerConfig)
                .then(response => {
                    return response;
                })
                .catch(error=>{
                   return error;
                });
            
        },

        async editHospital({ commit, rootState }, payload) {
            let headerConfig = {
                headers: {
                    Authorization: `bearer ${rootState.User.userToken}`
                },
            };
            
            return await this.$http.put(`api/administrators/hospitals/${payload.id}`, payload, headerConfig)
                .then(response => {
                    return response;
                }).catch(error => {
                    return error;
                });
        },

        setSelectedHospital({ commit }, payload) {
            commit('setSelectedHospital', payload)
        },

        
    },
    getters: {

        selectedHospital (state) {

            return state.selectedHospital;
        },

        hospitals (state) {
            
            return state.hospitals
        }
    }
};
